import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div className="flat-spacing pb-0 mb-5">
      <div className="container">
        <div className="title-success-order text-center">
          <img
            className="icon"
            src={`${process.env.PUBLIC_URL}/images/section/account-no-order.png`}
            alt="Success"
          />
          <div className="box-title">
            <h3 className="title">Whoops!</h3>
            <p className="text-md text-dark">
              We couldn’t find the page you were looking for.
            </p>
          </div>

          <div className="row mt-5">
            <div className="col-md-12 text-center">
              <Link to="/" className="me-3 m tf-btn animate-btn">
                Return to HomePage
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
